module.exports = __webpack_public_path__ + "media/KZ-ALM.443c0ab6.ogg";